import React, { useContext, useMemo } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import { ActionIcon, useLoadSavedHCPCS } from '@mummssoftware/common-ui';
import { GlobalContext } from '@mummssoftware/global-context/GlobalContext';
import { HCPCSContext } from '../Context/contexts/HCPCSContext';
import {
  ADD_SAVED_ICD_CODE,
  DELETE_HCPCS_CHOICE,
  RESET_HCPCS_FOR_RELOAD,
  SET_HCPCS_CHOICE,
  SET_HCPCS_DURATION,
  SET_ICD_SECTION,
  RECORD_DATA,
} from '../Context/constants';
import { HCPCSDuration } from './HCPCSDuration';
import { HCPCSCode } from './HCPCSCode';
import { AddICDCode } from './AddICDCode';
import { iconStyle } from './constants';
import {
  HCPCSWrapper,
  FlexGapDiv,
  HCPCSMainDiv,
  FullWidthDiv,
} from '../../components';
import defaults from '../../translations/en.json';

export const HCPCSSelection = () => {
  const { appVisit } = useContext(GlobalContext);
  const { hcpcsChoices, dispatchHCPCS } = useContext(HCPCSContext);

  const physicianServices = (appVisit as { physicianServices?: unknown } | null)
    ?.physicianServices as any[] | null | undefined;
  const hcpcsMenu = (window.env?.hcpcs?.doctor || []) as any[];

  /** Effect deps: `physicianServices` often gets a new array reference on each `appVisit` update; key by id + serialized rows so we do not reset/replay on every render. */
  const savedHcpcsLoadKey = useMemo(() => {
    const id = appVisit?.id ?? '';
    if (!physicianServices?.length) return `${id}:`;
    return `${id}:${JSON.stringify(physicianServices)}`;
  }, [appVisit?.id, physicianServices]);

  useLoadSavedHCPCS(
    (physicianServices as any) || null,
    dispatchHCPCS,
    hcpcsMenu,
    SET_HCPCS_CHOICE,
    SET_HCPCS_DURATION,
    SET_ICD_SECTION,
    ADD_SAVED_ICD_CODE,
    {
      resetType: RESET_HCPCS_FOR_RELOAD,
      deps: [savedHcpcsLoadKey],
    },
  );

  const getSelection = () =>
    hcpcsChoices && hcpcsChoices.length
      ? hcpcsChoices.map((choice: any) => {
          const key = choice.parentName
            ? `${choice.parentName} - ${choice.name}`
            : `${choice.name}`;
          return (
            choice.visible && (
              <FullWidthDiv key={key} id="hcpcs-section">
                <HCPCSMainDiv id="hcpcs-main-div">
                  <FlexGapDiv id="hcpcs-choice-div">
                    <ActionIcon
                      style={{ ...iconStyle, marginLeft: '-10px' }}
                      Icon={DeleteIcon}
                      onClick={() => {
                        dispatchHCPCS({
                          type: RECORD_DATA,
                          payload: true,
                        });
                        dispatchHCPCS({
                          type: DELETE_HCPCS_CHOICE,
                          payload: choice.key,
                        });
                      }}
                    />
                    {key}
                    <HCPCSDuration hcpcsChoice={choice} />
                    <HCPCSCode hcpcsChoice={choice} />
                  </FlexGapDiv>
                </HCPCSMainDiv>
                <AddICDCode hcpcsChoice={choice} />
              </FullWidthDiv>
            )
          );
        })
      : null;

  return (
    <HCPCSWrapper id="hcps-wrapper">
      <p>{defaults.hcpcsDoc}</p>
      {getSelection()}
    </HCPCSWrapper>
  );
};
